import React from "react";

import { SlideUpModal } from "./SlideUpModal";
import { SlideUpModalInput } from "./SlideUpModalInput";
import { Stack } from "@mui/material";
import { CloseModalButton } from "./CloseModalButton";
import { ModalSubmitButton } from "./ModalSubmitButton";

export const ShareLoanModal = ({ open, onClose, onFormEdit, onSubmit }) => (
  <SlideUpModal open={open} onClose={onClose}>
    <div className="review-loan-modal-container">
      <CloseModalButton onClick={onClose} />
      <Stack
        sx={{
          maxWidth: 300,
          margin: "60px 60px 10px 10px",
        }}
        gap={1}
      >
        <img
          className="share-loan-modal-header-image"
          src="/img/svg_icons/share.svg"
        />
        <h2>Share this loan option</h2>
        <span>
          We'll email a copy of this loan comparison to the email provided.
        </span>
        <SlideUpModalInput
          label="Your Email:"
          name="shareLoanEmail"
          onChange={onFormEdit}
        />
        <div className="submit-button-container">
          <ModalSubmitButton onClick={onSubmit}>Send</ModalSubmitButton>
        </div>
      </Stack>
    </div>
  </SlideUpModal>
);
